import ActionCable from "actioncable";
// @channel === class name
// @this.perform(@perform) === method name (def)
const cable = ActionCable.createConsumer(`${process.env.REACT_APP_SOCKET}`)
export default cable
